import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class EmployeeService {
  async fetch(page, perPage) {
    const response = await ajaxService.get(
      `/employees?page=${page}&perPage=${perPage}`
    );
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async addEmployee(data) {
    const response = await ajaxService.post(`/employees`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }

  async changeStatus(id) {
    const response = await ajaxService.get(`/employees/status/${id}`);
    if (response ?? false) {
      return response;
    }
  }
  async viewEmployee(id) {
    const response = await ajaxService.get(`/employees/${id}`);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async fetchPermissions() {
    const response = await ajaxService.get(`/permissions`);
    if (response ?? false) {
      return response;
    }
  }
  async editEmployee(id, updatedEmployee) {
    const response = await ajaxService.put(`/employees/`, id, updatedEmployee);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }

  async deleteEmployee(id) {
    const response = await ajaxService.delete(`/employees/`, id);
    if (response ?? false) {
      return response;
    }
  }
}

const employeeService = new EmployeeService();
export default employeeService;
